import * as React from 'react';
import { colors } from '../../../index';

const IconPrev = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 258 452",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.405 248.292l194.287 194.281c12.36 12.365 32.397 12.365 44.75 0 12.354-12.354 12.354-32.391 0-44.744L76.529 225.92l171.91-171.903c12.354-12.359 12.354-32.394 0-44.748-12.354-12.359-32.391-12.359-44.75 0L9.4 203.553c-6.177 6.18-9.263 14.271-9.263 22.366 0 8.099 3.092 16.196 9.267 22.373z"
  }));
};

export default IconPrev;